<template>
  <div class="library-upload-component">
    <div @click="uploadMediaClick">
      <slot></slot>
    </div>
    <input
      ref="inputFile"
      name="file"
      @change="upload"
      style="display: none"
      type="file"
      multiple="multiple"
      accept="image/*, video/mp4, video/mov"
    />
  </div>
</template>

<script>
import { showErrorMsg } from "../../utils/errors";
import { uploadMedia } from "../../service/media";

export default {
  name: "MediaLibraryUploadBtnComponent",
  props: {
    target: {
      type: String,
      default: "null",
    },
  },
  methods: {
    /**
     * 图片资源上传
     * @param event input文本框event
     */
    async upload(event) {
      // 显示Loading
      const loading = this.$loading({
        target: this.target || document.body,
      });
      try {
        let hasVideo = false;
        for (const file of event.target.files) {
          if (file.type === "video/mp4") {
            hasVideo = true;
            break;
          }
        }
        let result = [];
        if (hasVideo) {
          for (const file of event.target.files) {
            const m = await uploadMedia({ file });
            result.push(m);
          }
        } else {
          let promises = [];
          for (const file of event.target.files) {
            promises.push(uploadMedia({ file }));
          }
          result = await Promise.all(promises);
        }
        this.$emit("success", result);
      } catch (e) {
        showErrorMsg(e);
      } finally {
        loading.close();
        event.target.value = "";
      }
    },
    uploadMediaClick() {
      try {
        this.$refs.inputFile.click();
      } catch (e) {
        showErrorMsg(e);
      }
    },
  },
};
</script>
